function extractXStatusUrlCandidate(text: string): string | null {
    const raw = String(text || "");
    if (!raw) {
        return null;
    }

    const statusUrlMatch = raw.match(
        /https?:\/\/(?:www\.)?(?:twitter\.com|x\.com)\/[^\s"'<>/]+\/status\/\d+(?:(?:\?[^\s"'<>#]*)?(?:#[^\s"'<>]*)?)?/i,
    );
    if (statusUrlMatch && statusUrlMatch[0]) {
        return statusUrlMatch[0].trim();
    }

    const anchorPattern = /<a[^>]+href=["']([^"']+)["'][^>]*>/gi;
    let anchorMatch: RegExpExecArray | null;
    while ((anchorMatch = anchorPattern.exec(raw)) !== null) {
        const href = String(anchorMatch[1] || "").trim();
        if (!href) {
            continue;
        }

        if (/(?:twitter\.com|x\.com)\/[^\s"'<>/]+\/status\/\d+/i.test(href)) {
            return href;
        }
    }

    return null;
}

export function normalizeXStatusUrl(input: string): string | null {
    const raw = String(input || "").trim();
    if (!raw) {
        return null;
    }

    const match = raw.match(/^(?:https?:\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/([^\s"'<>/]+)\/status\/(\d+)/i);
    if (!match || !match[1] || !match[2]) {
        return null;
    }

    return `https://x.com/${match[1]}/status/${match[2]}`;
}

export function extractXStatusUrlFromOfficialEmbedHtml(htmlOrText: string): string | null {
    const candidate = extractXStatusUrlCandidate(String(htmlOrText || ""));
    if (!candidate) {
        return null;
    }

    return normalizeXStatusUrl(candidate) || candidate;
}
